import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, CalendarCheck, ShoppingBag } from 'lucide-react';
import { FloatingShapes } from './MemphisShapes';

const FinalCTA = () => {
  const buttons = [
    {
      icon: MapPin,
      label: "TROVA LOCALE",
      href: "#expansion",
      color: "bg-white text-black",
      testId: "cta-find-store"
    },
    {
      icon: CalendarCheck,
      label: "PRENOTA",
      href: "#",
      color: "bg-santomato-yellow text-black",
      testId: "cta-book",
      isBooking: true
    },
    {
      icon: ShoppingBag,
      label: "TAKEAWAY",
      href: "#",
      color: "bg-santomato-red text-white",
      testId: "cta-takeaway"
    }
  ];

  const handleClick = (button, e) => {
    if (button.isBooking) {
      e.preventDefault();
      window.open('https://santomato.plateform.app/r/prenotazionerapidasantomato', '_blank');
    } else if (button.href.startsWith('#')) {
      e.preventDefault();
      const element = document.querySelector(button.href);
      element?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      id="cta"
      data-testid="final-cta-section"
      className="min-h-[80vh] bg-black py-16 md:py-24 relative overflow-hidden flex items-center"
    >
      <FloatingShapes />
      
      <div className="max-w-4xl mx-auto px-4 md:px-8 text-center relative z-10">
        {/* Logo */}
        <motion.img
          src="https://customer-assets.emergentagent.com/job_santomato-pizza/artifacts/905354re_Tondo%20trasp.png"
          alt="SANTOMATO"
          initial={{ opacity: 0, scale: 0.8 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          className="w-32 h-32 md:w-48 md:h-48 mx-auto mb-8"
          data-testid="cta-logo"
        />

        {/* Main CTA Text */}
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="font-fredoka font-bold text-4xl sm:text-5xl md:text-6xl lg:text-7xl text-white uppercase mb-6"
          data-testid="cta-headline"
        >
          VIENI A
          <br />
          <span className="text-santomato-yellow">PROVARLA</span>
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
          className="font-nunito font-bold text-lg md:text-xl text-gray-300 mb-10 md:mb-14"
        >
          Pizza grande e generosa ti aspetta
        </motion.p>

        {/* CTA Buttons */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.3 }}
          className="flex flex-col sm:flex-row gap-4 justify-center items-center"
        >
          {buttons.map((button, index) => (
            <motion.a
              key={index}
              href={button.href}
              onClick={(e) => handleClick(button, e)}
              whileHover={{ scale: 1.05, y: -5 }}
              whileTap={{ scale: 0.95 }}
              className={`btn-brutal ${button.color} font-fredoka text-base md:text-lg px-6 md:px-8 py-4 rounded-full flex items-center gap-3 w-full sm:w-auto justify-center`}
              data-testid={button.testId}
            >
              <button.icon size={24} strokeWidth={2.5} />
              {button.label}
            </motion.a>
          ))}
        </motion.div>

        {/* Contact Info */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.5 }}
          className="mt-16 pt-8 border-t border-gray-800"
        >
          <p className="font-nunito text-gray-400 mb-2">
            Via Antonio Farina, 44 - Cigole (BS)
          </p>
          <a 
            href="tel:0307992227" 
            className="font-fredoka font-bold text-xl text-santomato-yellow hover:text-white transition-colors"
            data-testid="cta-phone"
          >
            030.7992227
          </a>
          <p className="font-nunito text-gray-500 text-sm mt-4">
            Gio-Dom 19:00/22:30 • Lun-Mer chiuso
          </p>
        </motion.div>
      </div>

      {/* Bottom decorative band */}
      <div className="absolute bottom-0 left-0 right-0 h-2 bg-santomato-yellow" />
    </section>
  );
};

export default FinalCTA;
